export default "__VITE_PUBLIC_ASSET__2bddb64c__"